// Utility methods for accessing device-specific information.

// returns : The unique device ID of this piece of hardware.
export const getDeviceId = () => localStorage.getItem('device_id')

// returns : The unique, expiring access token for this device.
export const getAccessToken = () => localStorage.getItem('accessToken')
